module.exports = __webpack_public_path__ + "media/images/img/office-e8e500aff416f9c2e598d3f8071c148b.jpeg";